import { TypeFiesta, TypeSmart } from '@at/design-system-foundation'
import styled from 'styled-components'

export const FinanceInfo = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.color.border.default};
    height: 50px;
    align-items: center;
`

export const FinanceInfoKey = styled(TypeFiesta)`
    font-size: 16px;
    font-variation-settings: 'wght' 400;
    color: ${({ theme }) => theme.color.text.title};
`

export const FinanceInfoValue = styled(TypeFiesta)`
    font-size: 16px;
    font-variation-settings: 'wght' 500;
    color: ${({ theme }) => theme.color.text.default};
`

export const FinanceLegalText = styled(TypeSmart)`
    font-size: 14px;
    color: ${({ theme }) => theme.color.text.default};
    > div {
        margin-top: 8px;
    }
`

export const FinanceTypePill = styled.div`
    border-radius: 29px;
    background-color: ${({ theme }) => theme.color.bgFill.intense};
    color: ${({ theme }) => theme.color.button.text.primary.default};
    font-size: 12px;
    padding: 8px 10px;
    height: 28px;
    display: flex;
    align-items: center;
`
